import { useCallback, useRef } from "react";

export const useAudio = () => {
  const audioContextRef = useRef<AudioContext | null>(null);

  const playBeep = useCallback(
    (frequency: number = 880, duration: number = 200) => {
      if (!audioContextRef.current) {
        audioContextRef.current = new (
          window.AudioContext || (window as any).webkitAudioContext
        )();
      }

      const ctx = audioContextRef.current;
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);

      oscillator.frequency.value = frequency;
      oscillator.type = "sine";

      gainNode.gain.setValueAtTime(0.5, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(
        0.01,
        ctx.currentTime + duration / 1000,
      );

      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + duration / 1000);
    },
    [],
  );

  const playPhaseChange = useCallback(
    (phase: "running" | "walking") => {
      // 러닝: 높은 음 2번 / 걷기: 낮은 음 1번
      if (phase === "running") {
        playBeep(880, 150);
        setTimeout(() => playBeep(880, 150), 200);
      } else {
        playBeep(440, 300);
      }
    },
    [playBeep],
  );

  return { playBeep, playPhaseChange };
};
